<div #buttonContainer></div>
@if (loading())
{
    <lib-frontend-spinner/>
}
<a class="btn" [href]="backUrl()">zurück</a>